import locales from "../locales";

const message = (lang, id) => {
  if (!locales || !locales[lang]) return id;
  const messages = locales[lang] || locales.en;
  return messages[id] || `??${id}??`;
};

export default message;
